import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import './PostBlogStyles.css';
import './ResponsiveBlogCard.css';

export const PostBlog = ({ qrUrl, storeUrl, storeType, badgeTitle, btnSub, btnTitle }) => {
    const isApple = storeType === 'apple';

    return (
        <a 
          href={storeUrl} 
          target="_blank" 
          rel="noopener noreferrer" 
          className={`PostBlog store-qr-card ${isApple ? 'ios' : 'android'}`}
          style={{ textDecoration: 'none', cursor: 'pointer' }}
        >
            <div className="store-badge-tag">{badgeTitle}</div>
            
            <div className="qr-container">
                <QRCodeCanvas 
                    value={qrUrl} 
                    size={150}
                    bgColor="#FFFFFF"
                    fgColor={isApple ? "#402864" : "#2A1844"}
                    level="H"
                    includeMargin={true}
                />
            </div>
            
            <p className="qr-scan-label">Scan with camera to download</p>

            <div className={`store-download-btn ${isApple ? 'apple-style' : 'play-style'}`}>
                {isApple ? <FaApple className="store-btn-icon" /> : <FaGooglePlay className="store-btn-icon" />}
                <div className="store-btn-text">
                    <span className="store-btn-sub">{btnSub}</span>
                    <span className="store-btn-main">{btnTitle}</span>
                </div>
            </div>
        </a>
    );
};